<template>
  <div class="flex flex_between">
    <md-field :class="[{ 'md-error': error }]">
      <label >{{ $t("common.assignmentType") }}</label>
      <TbSelect v-model="moduleValue"
				@md-selected="onSelect"
				options-value-field="value"
				:options-display-getter="(item) => $t(item.translationKey)"
				:options="options"
				:disabled="isDisabled"
				:required="required"
      />
      <span v-if="error" class="validation-error">{{ error }}</span>
    </md-field>
  </div>
</template>
<script>
import enumStatus from "@/common/enum";

export default {
  props: {
    error: { type: Boolean, default: "" },
    required: {type: Boolean, default: false},
    value: {type: String, default: ""},
  },
  data() {
    return {
      moduleValue: "",
      options: enumStatus.discloseList,
    };
  },
	computed: {
		isDisabled() {
			return this.$sessionStorage.get("localeUser").disableAuctionAssignment;
		}
	},
  mounted() {
    this.moduleValue = this.value;
  },
  methods: {
    onSelect(val) {
      this.$emit("input", val);
    }
  },
  watch: {
    value() {
      this.moduleValue = this.value;
    }
  }
};
</script>
